import React, { FC } from 'react';

import { useSeasonsMetadataQuery } from '../../hooks/useSeasonsMetadataQuery';

import styles from './_SeasonsList.module.css';
import { SeasonInfo } from './_SeasonInfo';

interface SeasonsListProps {
    onSelectSeason: (contentId: string) => void;
    filmId: string;
}

export const SeasonsList: FC<SeasonsListProps> = ({ onSelectSeason, filmId }) => {
    const {
        seasonsMetadata: { items: seasons },
    } = useSeasonsMetadataQuery({ id: filmId });

    return (
        <div className={styles.seasonsList}>
            {seasons.map(({ contentId, number, episodesCount }) => (
                <button
                    key={contentId}
                    onClick={() => onSelectSeason(contentId)}
                    className={styles.seasonButton}
                >
                    <SeasonInfo number={number} episodesCount={episodesCount} />
                </button>
            ))}
        </div>
    );
};
